import StorageLogo from '../../Icons/storage-logo.svg';
import AvailableStorageUnits from '../AvailableOptions/AvailableStorageUnits';
import Grid from '@mui/material/Grid';
import MyLabel from './MyLabel';
import StyledTextfield from './StyledTextfield';
import StyledSelect from './StyledSelect';
import PaperStyled from '../../PaperStyled';

const StorageSize = ({
  id,
  storageResult,
  setStorageResult,
  isDisabled,
  isDisabledUnits,
  storageUnits,
  setStorageUnits,
  md = 2.5,
  xs = 6,
  disabledcolor = 'black'
}) => {
  return (
    <>
      <Grid item md={md} xs={xs}>
        <PaperStyled>
          <MyLabel logo={StorageLogo} label="Storage Size" />
          <StyledTextfield
            id={id}
            type="number"
            value={storageResult}
            minValue={0}
            setValue={setStorageResult}
            isDisabled={isDisabled}
            disabledcolor={disabledcolor}
          />
        </PaperStyled>
      </Grid>
      <Grid item md={md} xs={xs}>
        <PaperStyled>
          <MyLabel logo="" label="Units" />
          <StyledSelect
            id={id + '-units'}
            labelId="units"
            value={storageUnits}
            setValue={setStorageUnits}
            optionsList={AvailableStorageUnits}
            isDisabled={isDisabledUnits}
          ></StyledSelect>
        </PaperStyled>
      </Grid>
    </>
  );
};
export default StorageSize;
